import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Canal } from '../../_models/canal';
import { ProductoService } from '../../_services/producto.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Producto } from '../../_models/producto';
import { CanalProductoService } from '../../_services/canal-producto.service';
import { CanalProducto } from '../../_models/canal-producto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import moment from 'moment';
import 'moment/locale/es';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-canales-productos',
  templateUrl: 'canales-productos.component.html'
})

export class CanalesProductosComponent implements OnInit {

  @Input() canal: Canal;
  @Output() dismiss: EventEmitter<string> = new EventEmitter();
  lisProductos: SelectItem[] = [];
  lisProductosTodos: Producto[] = [];
  carInformacionInicial = true;
  lisCanalesProductos: CanalProducto[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  canProducto: CanalProducto;
  columnas: any[];

  constructor(private proServicio: ProductoService,
    private conServicio: ConfirmationService,
    private canProductoServicio: CanalProductoService,
    private nav: NavService,
    private fb: FormBuilder) {

  }

  ngOnInit(): void {

    this.columnas = [
      { field: 'codigoProducto', header: this.nav.buscarMensaje('CANALESPRODUCTOS.LBL_CODIGOPRODUCTO'), sort: true },
      { field: 'nombreProducto', header: this.nav.buscarMensaje('CANALESPRODUCTOS.LBL_PRODUCTO'), sort: true },
      { field: 'tipoProductoBancario', header: this.nav.buscarMensaje('PRODUCTO.LBL_TIPOPRODUCTO'), sort: true },
      { field: 'indicadorHabilitado', header: this.nav.buscarMensaje('LBL_HABILITADO'), sort: true },
    ];


    forkJoin(
      this.canProductoServicio.obtenerPorIdCanal(this.canal.idCanal),
      this.proServicio.listado()
    ).subscribe(([prodCanales, productos]) => {
      this.lisCanalesProductos = prodCanales;
      productos = productos.sort(function (a, b) {
        return a.orden - b.orden;
      });
      productos.map((pro: Producto) => {
        if (pro.indicadorHabilitado) {
          this.lisProductosTodos.push(pro);
          if (!this.lisCanalesProductos.find(x => x.idProducto === pro.idProducto) && moment().isBetween(pro.fechaInicioVigencia, pro.fechaFinVigencia, null, '[]')) {
            this.lisProductos.push({ label: pro.nombre, value: pro.idProducto });
          }
        }
      });
      if (this.lisProductosTodos.length === 0) {
        this.lisProductosTodos = this.lisProductosTodos.sort(function (a, b) {
          return a.orden - b.orden;
        });
        this.nav.setMesage(4, {
          severity: 'info', summary: this.nav.buscarMensaje('LBL_INFORMACION'),
          detail: this.nav.buscarMensaje('CANALES.MSG_NOEXISTEPRODUCTOS')
        });
      }
      this.carInformacionInicial = false;

    });
    this.inicializarFormulario();

  }

  inicializarFormulario() {
    this.formulario = this.fb.group({
      idCanalProducto: [null],
      idProducto: [null, [Validators.required]],
      idCanal: [this.canal ? this.canal.idCanal : null, [Validators.required]],
      indicadorHabilitado: [true]
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.formulario.valid) {
      this.guardando = true;
      this.canProducto = this.formulario.value;
      this.canProductoServicio.crear(this.canProducto).subscribe(producto => {
        this.canProducto.idCanalProducto = producto.idCanalProducto;
        const p = this.lisProductosTodos.find(x => x.idProducto === this.canProducto.idProducto);
        if (p) {
          this.canProducto.nombreProducto = p.nombre;
          this.canProducto.codigoProducto = p.codigo;
          this.canProducto.tipoProductoBancario = p.tipoProductoBancario;
        }
        this.lisCanalesProductos.push(this.canProducto);
        const indice = this.lisProductos.findIndex(x => x.value === this.canProducto.idProducto);
        if (indice >= 0) {
          this.lisProductos.splice(indice, 1);
        }
        this.submitted = false;
        this.inicializarFormulario();
        this.guardando = false;
        this.nav.setMesage(1);
      }, error => {
        this.guardando = false;
        this.nav.setMesage(3);
      });
    }
  }

  cambiarHabilitado(canProducto: CanalProducto) {
    if (!canProducto.indicadorHabilitado) {
      this.conServicio.confirm({
        message: this.nav.buscarMensaje('MSG_INHABILITAR'),
        header: this.nav.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        key: 'productos',
        accept: () => {
          this.carInformacionInicial = true;
          this.canProductoServicio.actualizar(canProducto).subscribe(producto => {
            this.carInformacionInicial = false;
          });
        },
        reject: () => {
          canProducto.indicadorHabilitado = !canProducto.indicadorHabilitado;
        }
      });
    } else {
      this.carInformacionInicial = true;
      this.canProductoServicio.actualizar(canProducto).subscribe(producto => {
        this.carInformacionInicial = false;
      });
    }
  }

  irSiguiente() {
    this.dismiss.emit('ROL');
  }

  get f() {
    return this.formulario.controls;
  }

}
